<template>
  <div>
    <base-card>
      <div class="tw-divide-y tw-divide-gray-200" v-if="isLoading">
        <div class="tw-py-2 sm:tw-py-4 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-for="i in 3" :key="`info-loading-${i}`">
          <base-skeleton-loader class="tw-h-2 sm:tw-my-auto sm:tw-h-3 tw-w-12 tw-mt-1" />
          <dd class="tw-mt-1 tw-flex tw-text-sm tw-text-gray-900 sm:tw-mt-0 sm:tw-col-span-3">
            <div class="tw-flex-grow tw-flex tw-items-center tw-my-px">
              <base-skeleton-loader class="tw-h-3 tw-my-1.5 sm:tw-my-1 tw-w-24 tw-leading-6" />
            </div>
            <span class="tw-ml-4 tw-flex-shrink-0">
              <base-skeleton-loader class="tw-h-5 tw-w-12" />
            </span>
          </dd>
        </div>
      </div>
      <dl class="tw-divide-y tw-divide-gray-200 tw-mb-0" v-else>
        <update-business-member-full-name :member="member" :is-loading="fullNameLoading" :is-editing.sync="fullNameEditing" @updated="saveMember($event, 'fullName')" />
        <update-business-member-email :member="member" @updated="saveMember($event, 'fullName')" :business-id="businessId" :user-id="userId" />
        <update-business-member-phone-number :member="member" :is-loading="phoneNumberLoading" :is-editing.sync="phoneNumberEditing" @updated="saveMember($event, 'phoneNumber')" />
        <update-business-member-address
          :member="member"
          :is-loading="addressLoading"
          :is-editing.sync="addressEditing"
          @updated="saveMember($event, 'address')"
          v-if="organization.collectMailingAddressSetting"
        />
        <update-business-member-gender :member="member" :is-loading="genderLoading" :is-editing.sync="genderEditing" @updated="saveMember($event, 'gender')" />
        <update-business-member-dob
          :member="member"
          :is-loading="dobLoading"
          :is-editing.sync="dobEditing"
          @updated="saveMember($event, 'dob')"
          v-if="organization.collectDobSetting"
        />
        <update-business-member-last-appointment
          :member="member"
          :is-loading="lastAppointmentLoading"
          :is-editing.sync="lastAppointmentEditing"
          @updated="saveMember($event, 'lastAppointment')"
          v-if="organization.usePrescriptionProgramSetting"
        />
        <update-business-member-known-allergies
          :member="member"
          :is-loading="knownAllergiesLoading"
          :is-editing.sync="knownAllergiesEditing"
          @updated="saveMember($event, 'knownAllergies')"
          v-if="organization.usePrescriptionProgramSetting"
        />
      </dl>
    </base-card>
  </div>
</template>

<script>
import UpdateBusinessMemberFullName from "@/views/business/member/components/UpdateBusinessMemberFullName";
import UpdateBusinessMemberEmail from "@/views/business/member/components/UpdateBusinessMemberEmail";
import UpdateBusinessMemberPhoneNumber from "@/views/business/member/components/UpdateBusinessMemberPhoneNumber";
import UpdateBusinessMemberAddress from "@/views/business/member/components/UpdateBusinessMemberAddress";
import UpdateBusinessMemberGender from "@/views/business/member/components/UpdateBusinessMemberGender";
import UpdateBusinessMemberDob from "@/views/business/member/components/UpdateBusinessMemberDob";
import UpdateBusinessMemberLastAppointment from "@/views/business/member/components/UpdateBusinessMemberLastAppointment";
import UpdateBusinessMemberKnownAllergies from "@/views/business/member/components/UpdateBusinessMemberKnownAllergies";
import { mapGetters } from "vuex";
import { capitalize } from "lodash";

export default {
  components: {
    UpdateBusinessMemberFullName,
    UpdateBusinessMemberEmail,
    UpdateBusinessMemberPhoneNumber,
    UpdateBusinessMemberAddress,
    UpdateBusinessMemberGender,
    UpdateBusinessMemberDob,
    UpdateBusinessMemberLastAppointment,
    UpdateBusinessMemberKnownAllergies,
  },
  props: {
    isLoading: Boolean,
    member: Object,
    businessId: String,
    userId: String,
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  data() {
    return {
      editMember: {},
      fullNameLoading: false,
      fullNameEditing: false,
      phoneNumberLoading: false,
      phoneNumberEditing: false,
      addressLoading: false,
      addressEditing: false,
      genderLoading: false,
      genderEditing: false,
      dobLoading: false,
      dobEditing: false,
      lastAppointmentLoading: false,
      lastAppointmentEditing: false,
      knownAllergiesLoading: false,
      knownAllergiesEditing: false,
    };
  },
  methods: {
    async saveMember(member, loading) {
      try {
        this[`${loading}Loading`] = true;

        await this.$axios.put(`/businesses/${this.businessId}/members/${this.userId}`, member);
        this.$emit("updated", member);
        this[`${loading}Editing`] = false;
        this.EventBus.$emit("GLOBAL_NOTIFY", {
          title: `${capitalize(this.organization.customerLabelSingular)} updated`,
          message: `The ${this.organization.customerLabelSingular} was updated successfully`,
        });
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: `Unable to update ${this.organization.customerLabelSingular} details`,
          message: `We were not able to update the ${this.organization.customerLabelSingular} data. There may have been a connection error. Please reload the page to try again.`,
          error,
        });
      } finally {
        this[`${loading}Loading`] = false;
      }
    },
  },
  watch: {
    member: {
      immediate: true,
      deep: true,
      handler() {
        this.editMember = this.member;
      },
    },
  },
};
</script>
